"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BoundaryAssertionTypeSchema = exports.BoundaryAssertionType = void 0;
const zod_1 = require("zod");
var BoundaryAssertionType;
(function (BoundaryAssertionType) {
    BoundaryAssertionType["Numerical"] = "numerical";
    BoundaryAssertionType["Connection"] = "connection";
})(BoundaryAssertionType || (exports.BoundaryAssertionType = BoundaryAssertionType = {}));
exports.BoundaryAssertionTypeSchema = zod_1.z.nativeEnum(BoundaryAssertionType);
//# sourceMappingURL=BoundaryAssertionType.js.map